import { render, staticRenderFns } from "./ActionIframeDrawer.vue?vue&type=template&id=3fb3afd2"
import script from "./ActionIframeDrawer.vue?vue&type=script&lang=js"
export * from "./ActionIframeDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports